import React, { useState } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import { PersonOutline, ExpandMore } from '@mui/icons-material'
import useUser from '../../hooks/useUser'
import history from '../../history'
import styles from './Avatar.module.scss'

export default function Avatar() {
    const [anchorEl, setAnchorEl] = useState(null)

    const { logout, isLoggedIn, isAdmin } = useUser()

    const handleClick = (event) => setAnchorEl(event.currentTarget)
    
    const handleClose = () => setAnchorEl(null)
    
    const admin = () => {
        handleClose()
        history.push('/adminpanel')
    }

    const settings = () => {
        handleClose()
        history.push('/userSettings')
    }
    
    if (isLoggedIn) return (
        <>
            <Button
                onClick={handleClick}
                endIcon={<ExpandMore />}
                aria-controls='avatar-menu'
                aria-haspopup='true'
                variant='contained'
                size='small'
                color='secondary'
                classes={{ root: styles['root']}}
            >
                <PersonOutline className={styles['avatarUserIcon']} />
            </Button>
            <Menu 
                id='avatar-menu'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                transformOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                { isAdmin && <MenuItem onClick={admin}>Admin</MenuItem> }
                {/* <MenuItem onClick={settings} >Settings</MenuItem> */}
                <MenuItem onClick={logout}>Log out</MenuItem>
            </Menu>
        </>
        )
    else return <></>
}
